import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/menaceking-build-1752223655/layouts/default.vue").then(m => m.default || m)),
  "geo-restricted": defineAsyncComponent(() => import("/tmp/menaceking-build-1752223655/layouts/geo-restricted.vue").then(m => m.default || m))
}